import { atom } from "recoil";

export type SelectionType = {
  category:
    | {
        id: number;
        title: string;
      }
    | undefined;
  blog:
    | {
        news_id: number;
        news_title: string;
        title: string;
        url: string;
        published_date: string;
        content: string;
        description: string;
      }
    | undefined;
};

export const selectionAtom = atom<SelectionType>({
  key: "selectionAtom",
  default: {
    category: undefined,
    blog: undefined,
  },
});
